import { IconDefinition } from "./types";

const briefcase: IconDefinition = {
  iconName: "briefcase",
  width: 512,
  height: 512,
  svgPathData:
    "M168 0l-24 0 0 96-144 0 0 384 512 0 0-384-144 0 0-96-200 0zM464 256l-416 0 0-112 416 0 0 112zM320 304l144 0 0 128-416 0 0-128 144 0 0 48 128 0 0-48zm0-208l-128 0 0-48 128 0 0 48z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "briefcase",
  unicode: 0xf0b1,
};

export { briefcase };
